// src/pages/EmailInvalido.tsx

import React from 'react'
import { Button } from '@material-ui/core'
import { useNavigate } from 'react-router-dom'

const EmailInvalido = () => {
  const navigate = useNavigate()

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        fontFamily: 'Montserrat',
        padding: 20,
        textAlign: 'center'
      }}
    >
      <h1 style={{ color: '#d32f2f' }}>
        Link inválido ou expirado
      </h1>

      <p>
        Solicite uma nova validação de e-mail.
      </p>

      <Button
        variant="contained"
        style={{
          backgroundColor: '#1A3661',
          color: '#fff',
          marginTop: 20
        }}
        onClick={() => navigate('/login')}
      >
        Voltar para login
      </Button>
    </div>
  )
}

export default EmailInvalido